// Lazily load the Google Maps JavaScript API (with geometry) once, client-side.
// Requires NEXT_PUBLIC_GOOGLE_MAPS_API_KEY and the "Maps JavaScript API" enabled
// in Google Cloud (Places/Geocoding being enabled does NOT auto-enable this one).
let mapsPromise: Promise<any> | null = null;

export function loadGoogleMaps(): Promise<any> {
  if (typeof window === 'undefined') return Promise.reject(new Error('Google Maps can only load in the browser'));
  const w = window as any;
  if (w.google?.maps) return Promise.resolve(w.google);
  if (mapsPromise) return mapsPromise;

  const key = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
  mapsPromise = new Promise((resolve, reject) => {
    if (!key) { reject(new Error('Missing NEXT_PUBLIC_GOOGLE_MAPS_API_KEY')); return; }
    const existing = document.getElementById('gmaps-js') as HTMLScriptElement | null;
    if (existing) {
      existing.addEventListener('load', () => resolve(w.google));
      existing.addEventListener('error', () => reject(new Error('Failed to load Google Maps')));
      return;
    }
    const s = document.createElement('script');
    s.id = 'gmaps-js';
    s.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=geometry&v=weekly`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve(w.google);
    s.onerror = () => reject(new Error('Failed to load Google Maps'));
    document.head.appendChild(s);
  });
  return mapsPromise;
}
